<template>
  <div class="isTxt" v-if="isTxt">
    {{ name || '-' }}
  </div>
  <RxkSelect
    v-else
    :list="list"
    v-model="innerValue"
    @focus="remoteMethod"
    :disabled="renderConfig.disabled"
    @change="handleChange"
  />
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, unref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkSelect } from '@/components/common/RxkSelect'
import { getPageComponentData, getPageComponentDataEchoAcquire } from '@/apis/customerManage'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList', 'updadeViewData', 'blur'])

const innerValue = computed({
  get() {
    // console.log(props.modelValue, 'props.modelValue12333')
    return props.modelValue
  },
  set(newVal) {
    console.log(newVal, 'hghhhh')
    emit('update:modelValue', newVal)
  }
})
const flag = ref(true)
const list = ref([])
const name = ref('')

onMounted(async () => {
  console.log(props, 'props.data222')
  if (props.data.dataMark !== 2) {
    list.value = props.renderConfig.dataList || []
    getName(list.value)
  }
  if (props.data.dataMark === 2 && innerValue.value) {
    const postData = {
      columnId: props.data.id,
      echoData: innerValue.value
    }
    await getPageComponentDataEchoAcquire({ ...postData }).then(res => {
      console.log(res)
      list.value = res
      getName(res)
      emit('refreshDataList', unref(list))
      emit('updadeViewData', unref(innerValue))
    })
  } else {
    remoteMethod()
  }
})
watch(
  () => props.modelValue,
  () => {
    if (props.data.dataMark !== 2 && props.isTxt) {
      getName(list.value)
    }
  }
)

watch(
  () => props.isTxt,
  val => {
    if (val) {
      getName(list.value)
    }
  }
)

function remoteMethod() {
  // console.log(props.data)
  if (unref(flag) && props.data.dataMark === 2) {
    const postData = {
      tableCode: props.data.tableCode,
      columnId: props.data.id,
      columnUseScene: props.data.columnUseScene
    }
    getPageComponentData(postData).then(res => {
      list.value = res || []
      getName(res)
      flag.value = false
      emit('refreshDataList', res)
    })
  }
}

function getName(list: Recordable[]) {
  console.log(innerValue, list, 'lolll')
  if (isNullOrUndefOrEmpty(list) || isNullOrUndefOrEmpty(innerValue.value)) {
    name.value = '-'
    return
  }
  const current = list.find(item => String(item.value) === String(innerValue.value))
  console.log(current, 'current222')
  name.value = current ? current.label || '-' : '-'
}

function handleChange(e: string | any) {
  emit('blur', e)
}

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
